import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/store';
import { createAuthGuard } from '@/shared/auth/guards';
import { authRoutes } from '@/domains/@platform/auth/auth.routes';
import { adminRoutes } from '@/domains/@platform/admin/admin.routes';
import { jobsRoutes } from '@/domains/@platform/jobs/jobs.routes';
import { insightsRoutes } from '@/domains/@platform/insights/insights.routes';
import { chatRoutes } from '@/domains/@bot/chat/chat.routes';
import { pragyaaiRoutes, pragyaaiPublicRoutes } from '@/domains/@bot/pragyaai/pragyaai.routes';
import { widgetRoutes } from '@/domains/@bot/widget/widget.routes';
import { kcRoutes } from '@/domains/@content/kc/kc.routes';
import { itemgenRoutes } from '@/domains/@content/item-gen/itemgen.routes';
import { coursegenRoutes } from '@/domains/@content/course-content-gen/coursegen.routes';
import { authorsaideRoutes } from '@/domains/@content/authorsaide/authorsaide.routes';
import { podcastRoutes } from '@/domains/@content/podcast/podcast.routes';
import { resumeRoutes } from '@/domains/@resume/resume/resumeBuilder.routes';
import { careerRoutes } from '@/domains/@resume/career/career.routes';
import { checklistAdminRoutes, checklistLearnerRoutes } from '@/domains/@employer/checklist';
import { studentSupportRoutes } from '@/domains/@platform/student-support';

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/AdminLayout.vue'),
    children: [
      ...adminRoutes,
      ...jobsRoutes,
      ...insightsRoutes,
      ...chatRoutes,
      ...pragyaaiRoutes,
      ...kcRoutes,
      ...itemgenRoutes,
      ...coursegenRoutes,
      ...authorsaideRoutes,
      ...podcastRoutes,
      ...resumeRoutes,
      ...checklistAdminRoutes,
      ...studentSupportRoutes,
    ],
  },
  {
    path: '/ai-console',
    component: () => import('@/layouts/ConsoleLayout.vue'),
    children: [
      { path: '', redirect: '/manage-bot' },
      ...careerRoutes,
      ...checklistLearnerRoutes,
    ],
  },
  ...authRoutes,
  {
    path: '/iframe',
    component: () => import('@/layouts/PublicLayout.vue'),
    children: [
      {
        path: 'itemcustomization',
        name: 'itemcustomizationiframe',
        component: () => import('@/domains/@content/item-gen/views/ItemCustomizationView.vue'),
        meta: { public: true, ai: true },
      },
    ],
  },
  ...widgetRoutes,
  ...pragyaaiPublicRoutes,
  { path: '/ai-console/student-support', redirect: '/student-support' },
  { path: '/ai-console/resume-builder', redirect: '/resume-builder' },
  { path: '/ai-console/manage-bot', redirect: '/manage-bot' },
  { path: '/ai-console/manage-bot/:pathMatch(.*)*', redirect: to => `/manage-bot/${to.params.pathMatch || ''}` },
  { path: '/ai', redirect: '/manage-bot' },
  { path: '/ai/:pathMatch(.*)*', redirect: to => `/manage-bot/${to.params.pathMatch || ''}` },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: () => import('@/shared/ui/stubs/NotFound.vue'), meta: { public: true } },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach(createAuthGuard(store));

export default router;
